import { ListAlertConfigurations } from './ListAlertConfigurations/ListAlertConfigurations';
import { ListAlerts } from './ListAlerts';
import { ListAlertsData, ListAlertsQueryPayload } from './ListAlerts/includes/types';

export type Queries = {
  ListAlertConfigurations: typeof ListAlertConfigurations;
  ListAlerts: (payload: ListAlertsQueryPayload) => Promise<ListAlertsData>;
};

export const queries: Queries = {
  ListAlertConfigurations,
  ListAlerts,
};
